import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { dayBoundsIso } from '../../lib/time';
import { useLang } from '../../lib/lang';
import { useErrMsg } from '../../lib/errors';
import { ResourceTimeline } from './ResourceTimeline';

export function CalendarView({ branchId, date }: { branchId: number; date: string }): JSX.Element {
  const { t } = useLang();
  const errMsg = useErrMsg();
  const { from, to } = dayBoundsIso(date);
  const q = useQuery({
    queryKey: ['calendar', branchId, date],
    queryFn: () => api.calendar(branchId, { from, to, date }),
  });

  if (q.isLoading) {
    return <CenterNote>{t({ en: 'Loading calendar…', ar: 'جارٍ تحميل التقويم…' })}</CenterNote>;
  }
  if (q.isError || !q.data) {
    return <CenterNote tone="error">{errMsg(q.error, { en: 'Couldn’t load the calendar.', ar: 'تعذّر تحميل التقويم.' })}</CenterNote>;
  }
  if (q.data.resources.length === 0) {
    return <CenterNote>{t({ en: 'No bookable employees are assigned to this branch yet.', ar: 'لا يوجد موظفون قابلون للحجز في هذا الفرع بعد.' })}</CenterNote>;
  }
  return <ResourceTimeline data={q.data} date={date} branchId={branchId} />;
}

function CenterNote({ children, tone }: { children: React.ReactNode; tone?: 'error' }): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className={`text-sm ${tone === 'error' ? 'text-red-600' : 'text-slate-400'}`}>{children}</div>
    </div>
  );
}
